import Form from 'mobx-react-form';
import { muiFormBindings } from 'forms/utils/muiFormBindings';
import { plugins } from 'forms/utils/formPlugins';
import { FieldsDefinitions } from 'mobx-react-form/lib/models/FormInterface';
import { login } from 'utils/labels';
import { formOptions } from 'forms/utils/formOptions';
import { isEmail, isRequired } from 'forms/utils/validators';

const fields: FieldsDefinitions = [
  {
    name: 'email',
    label: login.email,
    bindings: 'TextField',
    value: '',
    validators: [isRequired, isEmail],
  },
  {
    name: 'password',
    label: login.password,
    bindings: 'TextField',
    type: 'password',
    value: '',
    validators: [isRequired],
  },
];

export function createForm() {
  return new Form({ fields }, { plugins, bindings: muiFormBindings, options: formOptions });
}
